@if (categoryWithSubcategory) {
  <button (click)="toggleSubcategory()" class="link icon" [ngClass]="{'uppercase' : categoryUppercase}">
    {{ categoryWithSubcategory.mainCategoryLabel ? (categoryWithSubcategory.mainCategoryLabel | translate) : categoryWithSubcategory.mainCategory }}
    <span appIcon="chevron-right"></span>
  </button>
  <div class="subcategory-container"
    [style.display]="internalMobileMenuIsOpen ? 'flex' : 'none'"
    [ngClass]="{'subcategory-toggle' : subcategoryIsOpen}"
    >
    <div class="subcategory-content">
      <button (click)="toggleSubcategory()" class="close icon">
        <span appIcon="arrow-left"></span>
        {{ 'common.back' | translate }}
      </button>
      @if (categoryWithSubcategory.mainCategory) {
        <div class="category-title">
          <h2>
            {{ categoryWithSubcategory.mainCategoryLabel ? (categoryWithSubcategory.mainCategoryLabel | translate) : categoryWithSubcategory.mainCategory }}
          </h2>
        </div>
      }
      <div class="subcategory-list">
        @if (categoryWithSubcategory.mainPageUrl && includeMainPageUrl) {
          <a [routerLink]="categoryWithSubcategory.mainPageUrl | translateRoute"
            routerLinkActive="active"
            class="link main-link"
            (click)="onLinkClick()"
            >
            {{'common.all' | translate}} {{ categoryWithSubcategory.mainCategoryLabel ? (categoryWithSubcategory.mainCategoryLabel | translate) : categoryWithSubcategory.mainCategory }}
          </a>
        }
        <div class="menu-section">
          @for (subcategory of categoryWithSubcategory.categories; track subcategory) {
            @if (subcategory.ppName) {
              <a [routerLink]="subcategory.ppName | positionedPageLink | async"
                (click)="onLinkClick()"
                class="link"
                >
                {{ subcategory.label ? (subcategory.label | translate) : subcategory.name }}
              </a>
            } @else {
              @if (subcategory.link) {
                @if (subcategory.link) {
                  <a
                    [routerLink]="subcategory.link | translateRoute"
                    (click)="onLinkClick()"
                    class="link"
                    >
                    {{ subcategory.label ? (subcategory.label | translate) : subcategory.name }}
                  </a>
                }
              } @else {
                @if (localization.currentLocale$ | async; as locale) {
                  @if (subcategory.externalLink) {
                    <a
                      [href]="subcategory.externalLink + (locale !== LocalesEnum.Nl ? LocalesEnum.En : LocalesEnum.Nl)"
                      (click)="onLinkClick()"
                      class="link"
                      >
                      {{ subcategory.label ? (subcategory.label | translate) : subcategory.name }}
                    </a>
                  }
                }
              }
            }
          }
        </div>
      </div>
      <div class="highlight-group">
        @for (highlight of categoryWithSubcategory.highlights | slice:0:3; track highlight) {
          @if (highlight.image | imageSize : 330; as highlightImage) {
            <a
              [href]="highlight.link"
              class="highlight-item"
              >
              <div class="highlight-image">
                <img [src]="highlightImage"
                  [alt]="highlight.title"
                  loading="lazy"
                  />
              </div>
              @if (highlight) {
                <label
                  class="highlight-label"
                  >
                  {{ 'navigation.highlighted' | translate }}
                </label>
              }
              <div class="highlight-title">
                <h2 class="text-white">
                  {{ highlight.title }}
                </h2>
              </div>
            </a>
          }
        }
      </div>
    </div>
  </div>
}

@if (sectionWithSubcategory) {
  <div class="dealer-account">
    <h2 class="subheading">
      {{ 'template.site-header.dealer-account' | translate }}
    </h2>
    <button (click)="toggleSubcategory()" class="link icon" [ngClass]="{'uppercase' : categoryUppercase}">
      <div class="user">
        <span appIcon="user"></span>
        {{ sectionWithSubcategory.dropdownButtonLabel ? (sectionWithSubcategory.dropdownButtonLabel | translate) : sectionWithSubcategory.dropdownButtonText }}
      </div>
      <span appIcon="chevron-right"></span>
    </button>
  </div>
  <div class="subcategory-container"
    [ngClass]="{'subcategory-toggle' : subcategoryIsOpen}"
    >
    <div class="subcategory-content">
      <button (click)="toggleSubcategory()" class="close icon">
        <span appIcon="arrow-left"></span>
        {{ 'common.back' | translate }}
      </button>
      <div class="category-title">
        <h2>
          {{ 'template.site-header.dealer-account' | translate }}
        </h2>
      </div>
      <div class="subcategory-list">
        <div class="menu-section no-border no-padding">
          @for (subcategory of sectionWithSubcategory.dropdownItems; track subcategory) {
            @if (subcategory.clickEvent) {
              <a
                class="link"
                (click)="subcategory.clickEvent($event)"
                >
                {{ subcategory.itemLabel ? (subcategory.itemLabel | translate) : subcategory.itemName }}
              </a>
            }
            @if (subcategory.routerLink) {
              <a
                [routerLink]="subcategory.routerLink | translateRoute"
                class="link"
                >
                {{ subcategory.itemLabel ? (subcategory.itemLabel | translate) : subcategory.itemName }}
              </a>
            }
            @if (subcategory.ppName) {
              @if (subcategory.ppName | positionedPageLink | async; as link) {
                <a
                  [routerLink]="link"
                  class="link"
                  >
                  {{ subcategory.ppName | positionedPageTitle | async }}
                </a>
              }
            }
            @if (subcategory.underLine) {
              <hr class="split-section" />
            }
          }
          <hr class="underline" />
          <app-checkbox [control]="updateProfileService.hidePurchasePrice"
            [nativeMode]="true"
            class="dropdown-item"
            [smallLabel]="true"
            >
            {{ 'my-data.hide-purchase-price' | translate }}
          </app-checkbox>
        </div>
      </div>
    </div>
  </div>
}
